import { EventEmitter, Injectable } from '@angular/core';
import { OrdersService, WatchlistService } from '@evermile/customer-tracking';
import { EditOrderRequest } from '@evermile/customer-tracking/model/editOrderRequest';
import { DateProposals } from '@evermile/customer-tracking/model/dateProposals';
import { TimeslotProposal } from '@evermile/customer-tracking/model/timeslotProposal';
import { GtmTracking } from './gtm.service';

export interface MenuOption {
  iconComponent: any;
  title: string;
  action: EditOrderFlowTypes | EditOrderInstructionsFlowTypes;
}
export enum EditOrderFlowTypes {
  ChangeDateAndTime = 'changeDateAndTime',
  ChangeAddress = 'changeAddress',
  AddInstructions = 'addInstructions',
  ChangeRecipientDetails = 'changeRecipientDetails',
  Contact = 'contact',
}

export enum EditOrderInstructionsFlowTypes {
  Neighbour = 'leaveWithNeighbour',
  SafePlace = 'DeliverToASafePlace',
  CourierNote = 'leaveNoteToTheCourier',
}
@Injectable({
  providedIn: 'root',
})
export class EditOrderService {
  currentIndex = 0;

  startStepper = new EventEmitter();
  startStepper$ = this.startStepper.asObservable();

  openRebookFlow = new EventEmitter();
  openRebookFlow$ = this.openRebookFlow.asObservable();

  emitNextStep = new EventEmitter();
  emitNextStep$ = this.emitNextStep.asObservable();

  emitTitle: EventEmitter<string> = new EventEmitter();
  emitTitle$ = this.emitTitle.asObservable();

  emitInstructionsOption: EventEmitter<EditOrderInstructionsFlowTypes> = new EventEmitter();
  emitInstructionsOption$ = this.emitInstructionsOption.asObservable();

  hideBackArrow: EventEmitter<boolean> = new EventEmitter();
  hideBackArrow$ = this.hideBackArrow.asObservable();

  hideCloseButton: EventEmitter<boolean> = new EventEmitter();
  hideCloseButton$ = this.hideCloseButton.asObservable();

  closeMenu = new EventEmitter();
  closeMenu$ = this.closeMenu.asObservable();

  afterIndexChange: EventEmitter<number> = new EventEmitter();
  afterIndexChange$ = this.afterIndexChange.asObservable();

  orderWasUpdated: EventEmitter<number> = new EventEmitter();
  orderWasUpdated$ = this.orderWasUpdated.asObservable();

  showErrorScreen = new EventEmitter();
  showErrorScreen$ = this.showErrorScreen.asObservable();

  contactUs = new EventEmitter();
  contactUs$ = this.contactUs.asObservable();

  constructor(
    private apiEditOrderService: OrdersService,
    private watchlistService: WatchlistService,
    private gtm: GtmTracking,
  ) {}

  setCurrentIndex(val: number) {
    this.currentIndex = val;
    this.afterIndexChange.emit(this.currentIndex);
  }

  onChooseDeliveryInstructionsOption(option: MenuOption, type: EditOrderInstructionsFlowTypes) {
    this.emitNextStep.emit();
    this.emitInstructionsOption.emit(type);
    this.emitTitle.emit(option.title);
  }

  submitEditOrder(body: EditOrderRequest) {
    this.apiEditOrderService.orderEditPost(body).subscribe(
      (data) => {
        this.emitNextStep.emit();
        this.orderWasUpdated.emit();
        this.gtm.submitForm('Edit delivery', body);
      },
      (err) => {
        this.showErrorScreen.emit();
        this.gtm.invalidForm('Edit delivery', body, err);
      },
    );
  }

  areThereValidProposals(proposals: Array<DateProposals>) {
    const allProposalArray = proposals.reduce((acc: Array<TimeslotProposal>, p: DateProposals) => {
      acc = acc.concat(p.proposals);
      return acc;
    }, []);
    return allProposalArray.some((p) => p.proposal);
  }

  selectRebookOption(taskId: string, proposalId: string) {
    return this.watchlistService.postTaskUpdate(taskId, {
      updateType: 'proposalSelection',
      updateData: { proposalId },
    });
  }
}
